// extracted by mini-css-extract-plugin
module.exports = {"root":"Textarea_root__2BBKF","error":"Textarea_error__3Jp_b","readonly":"Textarea_readonly__3HZvi","disabled":"Textarea_disabled__soYhe"};